import { motion } from "framer-motion";
import { Radio, Eye, Rocket } from "lucide-react";

const STEPS = [
  {
    Icon: Radio,
    title: "1. Rank your site",
    text: "$1 lists your URL on the board. Pay $1 over the seat above to overtake.",
    cls: "text-gmh-orange border-gmh-orange/30",
  },
  {
    Icon: Eye,
    title: "2. Get in front of people watching Sam",
    text: "Higher rank means more clicks from people following the rescue — without a big ad budget.",
    cls: "text-gmh-cyan border-gmh-cyan/30",
  },
  {
    Icon: Rocket,
    title: "3. Help Sam get closer to Earth",
    text: "Bids add fuel. The ship on the first fold moves as the board fills.",
    cls: "text-slate-300 border-slate-500/40",
  },
];

export const Protocol = () => (
  <section className="mx-auto max-w-6xl border-t border-[#141d34] px-4 py-16 sm:px-6">
    <div className="mono mb-12 text-center text-xs tracking-[0.5em] text-slate-500">MISSION PROTOCOL</div>
    <div className="grid gap-10 sm:grid-cols-3">
      {STEPS.map(({ Icon, title, text, cls }, i) => (
        <motion.div
          key={title}
          initial={{ y: 30, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
          className="text-center"
          data-testid={`protocol-step-${i + 1}`}
        >
          <div className={`panel mx-auto flex h-16 w-16 items-center justify-center border ${cls}`}>
            <Icon size={24} />
          </div>
          <h3 className="mt-5 text-lg font-bold text-white">{title}</h3>
          <p className="mx-auto mt-2 max-w-xs text-sm leading-relaxed text-slate-500">{text}</p>
        </motion.div>
      ))}
    </div>
  </section>
);
